"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Facbebook = function Facbebook(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 10.06c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 4.99 3.66 9.13 8.44 9.88v-6.99H5.9v-2.89h2.54v-2.2c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46H13.2c-1.24 0-1.63.77-1.63 1.56v1.88h2.77l-.44 2.89h-2.33v6.99c4.78-.75 8.44-4.89 8.44-9.88z",
    style: {
      fill: "#fff"
    }
  }));
};

Facbebook.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};

var Instagram = function Instagram(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.86.07C4.8.12 4.07.29 3.43.54c-.66.26-1.21.6-1.77 1.16-.56.56-.9 1.12-1.15 1.77C.26 4.11.1 4.83.05 5.9 0 6.96 0 7.3 0 10.02s.02 3.06.07 4.12.22 1.79.47 2.43c.26.66.6 1.21 1.16 1.77.56.55 1.12.9 1.77 1.15.64.25 1.36.41 2.43.46 1.07.05 1.41.06 4.12.05 2.72 0 3.06-.02 4.12-.07s1.79-.22 2.43-.47c.66-.26 1.21-.6 1.77-1.16.55-.56.9-1.12 1.15-1.77.25-.64.41-1.36.46-2.43.05-1.07.06-1.41.05-4.12 0-2.72-.02-3.06-.07-4.12s-.22-1.79-.47-2.43c-.26-.66-.6-1.21-1.16-1.77-.56-.55-1.12-.9-1.77-1.15C15.89.26 15.17.1 14.1.05 13.04 0 12.7 0 9.98 0S6.92.02 5.86.07m.12 18.08c-.97-.04-1.5-.2-1.86-.34-.47-.18-.8-.4-1.15-.75a3.06 3.06 0 0 1-.75-1.15c-.14-.35-.3-.88-.35-1.86-.05-1.05-.06-1.37-.07-4.04 0-2.67 0-2.99.05-4.04.04-.97.2-1.5.34-1.86.18-.47.4-.8.75-1.15.35-.35.68-.57 1.15-.75.35-.14.88-.3 1.86-.35C7 1.81 7.32 1.8 9.99 1.79c2.67 0 2.99 0 4.04.05.97.04 1.5.2 1.86.34.47.18.8.4 1.15.75.35.35.57.68.75 1.15.14.35.3.88.35 1.86.05 1.05.06 1.37.07 4.04 0 2.67 0 2.99-.05 4.04-.04.97-.2 1.5-.34 1.86-.18.47-.4.8-.75 1.15-.35.35-.68.57-1.15.75-.35.14-.88.3-1.86.35-1.05.05-1.37.06-4.04.07-2.67 0-2.99 0-4.04-.05m8.15-13.5c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2s-1.2.54-1.2 1.2m-9.26 5.36c0 2.84 2.31 5.13 5.14 5.12 2.84 0 5.13-2.31 5.13-5.14 0-2.84-2.31-5.13-5.15-5.12-2.84 0-5.13 2.31-5.12 5.14m1.8 0c0-1.84 1.49-3.34 3.33-3.34s3.34 1.49 3.34 3.33-1.49 3.34-3.33 3.34-3.34-1.49-3.34-3.33",
    style: {
      fill: "#fff"
    }
  }));
};

Instagram.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};

var LinkedIn = function LinkedIn(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.54 0H1.46C.65 0 0 .65 0 1.46v17.08C0 19.35.65 20 1.46 20h17.08c.81 0 1.46-.65 1.46-1.46V1.46C20 .65 19.35 0 18.54 0zM5.83 17.08H2.92V7.5h2.92v9.58zm.25-12.65c-.02.92-.79 1.65-1.71 1.62h-.02c-.94-.01-1.7-.79-1.69-1.73.01-.94.79-1.7 1.73-1.69.94.01 1.7.79 1.69 1.73v.06zm11 12.65h-2.92v-5.04c0-1.54-.85-2.18-1.69-2.18-1.02 0-2.06.68-2.06 2.22v5H7.49V7.5h2.75v1.35h.04c.28-.59 1.52-1.56 3.19-1.56s3.6 1.13 3.6 4.05v5.74z",
    style: {
      fill: "#fff"
    }
  }));
};

LinkedIn.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};

var Medium = function Medium(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, ".cls-1", "{", "fill:#fff", "}")), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Symbol"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M11.28 10.02c0 3.14-2.53 5.68-5.64 5.68S0 13.16 0 10.02s2.53-5.68 5.64-5.68 5.64 2.54 5.64 5.68M17.47 10.02c0 2.95-1.26 5.35-2.82 5.35s-2.82-2.39-2.82-5.35 1.26-5.35 2.82-5.35 2.82 2.39 2.82 5.35M20 10.02c0 2.64-.44 4.79-.99 4.79s-.99-2.14-.99-4.79.44-4.79.99-4.79.99 2.14.99 4.79"
  }))));
};

Medium.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};

var Twitter = function Twitter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm5.02 8.11v.31c0 3.18-2.42 6.86-6.86 6.86-1.36 0-2.63-.4-3.69-1.09.19.02.38.04.58.04 1.13 0 2.17-.39 3-1.03a2.403 2.403 0 0 1-2.25-1.67c.15.03.3.04.45.04.22 0 .44-.03.64-.08-1.1-.23-1.94-1.2-1.94-2.37v-.03c.32.18.7.29 1.09.3a2.402 2.402 0 0 1-1.08-2c0-.44.12-.86.33-1.21a6.83 6.83 0 0 0 4.97 2.52c-.05-.18-.06-.36-.06-.55a2.411 2.411 0 0 1 4.17-1.65 4.95 4.95 0 0 0 1.53-.58c-.18.56-.56 1.03-1.06 1.33.49-.06.95-.19 1.39-.38-.32.49-.74.91-1.21 1.25z",
    style: {
      fill: "#fff"
    }
  }));
};

Twitter.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};

var FooterWrapper = _styledComponents["default"].div.withConfig({
  displayName: "BusinessFooter__FooterWrapper",
  componentId: "zddh9-0"
})(["background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme !== null && theme !== void 0 ? theme : "#9121c2";
});

var SVGWrapper = _styledComponents["default"].div.withConfig({
  displayName: "BusinessFooter__SVGWrapper",
  componentId: "zddh9-1"
})(["display:flex;align-items:center;justify-content:center;gap:15px;width:100%;height:100%;* svg{width:25px;}* p{font-style:normal;color:white;font-weight:medium;font-size:0.75em;white-space:nowrap;}"]);

var BusinessFooter = function BusinessFooter(_ref2) {
  var _links$facebook, _links$instagram, _links$linkedin, _links$medium, _links$twitter;

  var links = _ref2.links,
      theme = _ref2.theme;

  if (links === undefined || !Object.keys(links).length) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }

  var emptyUrls;
  Object.keys(links).map(function (key) {
    var _links$key, _links$key$url;

    if (emptyUrls === false) {
      return;
    }

    if (!((_links$key = links[key]) !== null && _links$key !== void 0 && (_links$key$url = _links$key.url) !== null && _links$key$url !== void 0 && _links$key$url.length)) {
      emptyUrls = true;
    } else {
      emptyUrls = false;
    }
  });

  if (emptyUrls) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }

  return /*#__PURE__*/_react["default"].createElement(FooterWrapper, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(SVGWrapper, null, (links === null || links === void 0 ? void 0 : (_links$facebook = links.facebook) === null || _links$facebook === void 0 ? void 0 : _links$facebook.url) && /*#__PURE__*/_react["default"].createElement("a", {
    href: links.facebook.url
  }, /*#__PURE__*/_react["default"].createElement(Facbebook, null)), (links === null || links === void 0 ? void 0 : (_links$instagram = links.instagram) === null || _links$instagram === void 0 ? void 0 : _links$instagram.url) && /*#__PURE__*/_react["default"].createElement("a", {
    href: links.instagram.url
  }, /*#__PURE__*/_react["default"].createElement(Instagram, null)), (links === null || links === void 0 ? void 0 : (_links$linkedin = links.linkedin) === null || _links$linkedin === void 0 ? void 0 : _links$linkedin.url) && /*#__PURE__*/_react["default"].createElement("a", {
    href: links.linkedin.url
  }, /*#__PURE__*/_react["default"].createElement(LinkedIn, null)), (links === null || links === void 0 ? void 0 : (_links$medium = links.medium) === null || _links$medium === void 0 ? void 0 : _links$medium.url) && /*#__PURE__*/_react["default"].createElement("a", {
    href: links.medium.url
  }, /*#__PURE__*/_react["default"].createElement(Medium, null)), (links === null || links === void 0 ? void 0 : (_links$twitter = links.twitter) === null || _links$twitter === void 0 ? void 0 : _links$twitter.url) && /*#__PURE__*/_react["default"].createElement("a", {
    href: links.twitter.url
  }, /*#__PURE__*/_react["default"].createElement(Twitter, null))));
};

exports.BusinessFooter = BusinessFooter;